module.exports = __webpack_public_path__ + "static/15-1c5539bf6d782855d0e7ad5846d07ff5.png";